import React from "react";
import styled from "styled-components";
import { Row } from "@ui/components/layout";

interface LivecourseWorkspaceLabelProps extends React.HTMLAttributes<HTMLDivElement> {
	workspace: string;
}
export const LivecourseWorkspaceLabel: React.FC<LivecourseWorkspaceLabelProps> = ({ workspace, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<Row gap={4} align="center">
				<Cercle />
				{workspace}
			</Row>
		</Container>
	);
};

const Container = styled.div`
	background-color: ${({ theme }) => theme.colors.simplegray};
	border-radius: 50px;
	border: 1px solid ${({ theme }) => theme.colors.secondaryLight};
	padding: 9px 12px 7px;
	${({ theme }) => theme.textStyles.label};
	color: ${({ theme }) => theme.colors.secondary};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: auto;
	max-width: 285px;
`;

const Cercle = styled.div`
	background-color: ${({ theme }) => theme.colors.secondary};
	height: 10px;
	width: 10px;
	margin-right: 5px;
	border-radius: 8px;
`;
